import React from 'react';
import { FadeLoader } from 'react-spinners';
import { styledTheme } from 'globalStyles/theme';

const Loading = () => (
  <section className="app_loader">
    <FadeLoader
      color={styledTheme.lighterGray}
      loading
      height={15}
      width={5}
      radius={5}
      margin={2}
    />
  </section>
);

export default Loading;
